import { IntegrateSideMenu } from "@/components/flow/shared/Deploy/IntegrateSideMenu";
import { IntegrateSidebarActions } from "@/components/flow/shared/Deploy/IntegrateSidebarActions";
import { BuildSteps, Flows } from "@/types/flows";
import { SidebarHeader } from "@/components/layout/SidebarHeader";
export function DeploySidebarContent() {
    return (
        <>
            <SidebarHeader title="How do you want to use your model?" />
            <IntegrateSideMenu />
            <IntegrateSidebarActions previousFlow={Flows.BUILD} previousStep={BuildSteps.REVIEW} />
        </>
    );
}
